import { render, staticRenderFns } from "./ProdAbnormalList.vue?vue&type=template&id=81eeed38&"
import script from "./ProdAbnormalList.vue?vue&type=script&lang=js&"
export * from "./ProdAbnormalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports